<template>
    <div class="page productSingle" @scroll="pageScroll" ref="page">
        
        <transition-group name="fade">
            <div style="animation-duration: 0.3s" v-if="( currentProduct.id != $route.query.product )" :key="1"
                 class="preloader">
                <img :src="getStaticImage('logo.png')" alt="">
                <Loader></Loader>
            </div>
            <div v-else :key="2" class="recipeContainer">
                <div class="pageContainer">
                    <div class="container">
                        <h2 class="d-flex jus">
                            <span><img :src="getStaticImage('icon-arrow-left.png')" @click="$router.go(-1)"
                                       alt="back"></span>
                            <span class="text-center flex-grow-1">{{currentProduct.title}}</span>
                            
                            <span style="width: 35px"></span>
                        </h2>
                        
                        <div class="actions">
                            <span @click="shareThis({ title: currentProduct.title, text: '', url: href})">
                                <img width="24" :src="getStaticImage('icon-share.png')">
                            </span>
                        </div>
                        
                        <div class="text-center">
                            <div class="imgBox">
                                <div class="contentContainer">
                                    <img class="img-fluid"
                                         :src="currentProduct.featured_image ? currentProduct.featured_image : getStaticImage('logo.png')"><br>
                                </div>
                            </div>
                            
                            <router-link class="mkButton mkBig"
                                         :to="{name:'recipes', query : { filter : currentProduct.filter  } }">{{ $t('product.View All Recipes') }}
                            </router-link>
                        
                        </div>
                    </div>
                </div>
                
                <ul class="details" id="productDesc">
                    <li v-if="currentProduct.product_specification">
                        <div class="container">
                            <div class="title">
                                <span> {{ $t('product.Product Specifications') }}</span>
                                <span class="size">{{ currentProduct.size ? currentProduct.size.replace(/<(.|\n)*?>/g, '') : ""}}</span>
                            </div>
                            <div class="hidden" v-if="getLng() == 'en'">
                                {{ currentProduct.product_specification ?
                                currentProduct.product_specification.replace(/<(.|\n)*?>/g, '') : ""}}
                            </div>
                            <div class="hidden" v-else>
                                {{ currentProduct.product_specification_spanish ?
                                currentProduct.product_specification_spanish.replace(/<(.|\n)*?>/g, '') : ""}}
                            </div>
                        </div>
                    </li>
                    <li v-if="currentProduct.product_features">
                        <div class="container">
                            <div class="title"> {{ $t('product.Product Features') }}</div>
                            <div class="hidden" v-if="getLng() == 'en'" v-html="currentProduct.product_features"></div>
                            <div class="hidden" v-else v-html="currentProduct.product_features_spanish"></div>
                        </div>
                    </li>
                    <li v-if="currentProduct.fruit_analysis">
                        <div class="container">
                            <div class="title"> {{ $t('product.Fruit Analysis') }}</div>
                            <div class="hidden" v-if="getLng() == 'en'" v-html="currentProduct.fruit_analysis"></div>
                            <div class="hidden" v-else v-html="currentProduct.fruit_analysis_spanish"></div>
                            
                        </div>
                    </li>
                    <li v-if="currentProduct.upc_code || currentProduct.item_number">
                        <div class="container">
                            <div class="title"> {{ $t('product.UPC Code & Item Number') }}</div>
                            <div class="hidden">
                                <ul>
                                    <li>{{ $t('product.UPC Code') }} : {{ currentProduct.upc_code ?
                                        currentProduct.upc_code.replace(/<(.|\n)*?>/g, '') : "" }}
                                    </li>
                                    <li>{{ $t('product.Item Number') }} : {{ currentProduct.item_number ?
                                        currentProduct.item_number.replace(/<(.|\n)*?>/g, '') : "" }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </li>
                    <li v-if="currentProduct.closure_type">
                        <div class="container">
                            <div class="title">{{ $t('product.Closure Type') }}</div>
                            <div class="hidden" v-html="">
                                {{currentProduct.closure_type ? currentProduct.closure_type.replace(/<(.|\n)*?>/g, '') :
                                ""}}
                            </div>
                        </div>
                    </li>
                    <li v-if="currentProduct.shelf_life">
                        <div class="container">
                            <div class="title">{{ $t('product.Shelf Life') }}</div>
                            <div class="hidden shelf_life" v-if="getLng() == 'en'" v-html="currentProduct.shelf_life"></div>
                            <div class="hidden shelf_life" v-else v-html="currentProduct.shelf_life_spanish"></div>
                        </div>
                    </li>
                    <li v-if="currentProduct.behind_bar">
                        <div class="container">
                            <div class="title">{{ $t('product.Behind the Bar') }}</div>
                            <div class="hidden" v-if="getLng() == 'en'" v-html="currentProduct.behind_bar"></div>
                            <div class="hidden" v-else v-html="currentProduct.behind_bar_spanish"></div>
                        </div>
                    </li>
                </ul>
                
                <div
                    class="sliderBox"
                    v-if="currentProduct.recipes && Object.keys(currentProduct.recipes.data).length"
                >
                    <!--v-touch:swipe.stop-->
                    
                    <h4>
                    <div class="container">
                            <span>
                                <img :src="getStaticImage('icon-grid.svg')" alt=""> {{ $t('product.Recipes using this Product') }}
                            </span>
                        </div>
                    </h4>
                    
                    <div class="slideContainer">
                        <div class="slideRecipes">
                            <div v-for="recipe in currentProduct.recipes.data" class="slide">
                                <router-link :to="{name:'recipes', query : { recipe : recipe.id  } }">
                                    
                                    <div class="imgBox">
                                        <img :src="recipe.image ? recipe.image : getStaticImage('logo.png') " alt="">
                                    </div>
                                    {{recipe.title}}
                                </router-link>
                            </div>
                            
                            <div class="slide last">
                                <router-link class="d-flex align-items-center justify-content-center"
                                             :to="{name:'recipes', query : { filter : currentProduct.filter  } }">
                                    <span class="mkButton mkBig">{{ $t('product.View All') }}</span>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            
            </div>
        </transition-group>
    
    </div>
</template>

<script>

    import {mapState} from "vuex";
    import shareMixin from "../../mixins/share"
    import pageMixin from "../../mixins/page"
    import $ from "jquery"
    import Flickity from 'flickity';
    import "slick-carousel";
    import 'flickity/dist/flickity.min.css';
    import Loader from "../Loader";

    export default {
        name: 'ProductSingle',
        components: {Loader},
        mixins: [shareMixin, pageMixin],
        data() {
            return {
                flickity: null,
                flickityOptions: {
                    freeScroll: true,
                    // any options from Flickity can be used
                },
                href: window.location.href
            }
        },
        computed: {
            ...mapState("product", ["currentProduct"])
        },
        methods: {
            initProduct() {
                //Title
                if (this.$route.query.brand === "real"){
                    this.changePageTitle( this.currentProduct.title + "  | Reàl Ingredients | ABM Cocktail Pro" );
                }else{
                    this.changePageTitle( this.currentProduct.title  + "  | Finest Call | ABM Cocktail Pro" );
                }
                if(this.$route.query.product === '41'){
                    window.location.href = '/';
                }
                //##########################
                let self = this;
                setTimeout(function () { //waiting before everything is gonna show
                    $("#productDesc .title:not(.hasFunc)").addClass('hasFunc').click(function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        $("#productDesc .title").not(this).removeClass("active").next(".hidden").slideUp();
                        $(this).toggleClass("active").next(".hidden").slideToggle();
                    });

                    $("#productDesc .title.hasFunc").eq(0).not(".active").click();

                    if ($('.slideRecipes').length) {

                        /*$('.slideRecipes').slick({
                            dots:false,
                            arrows: false,
                            slidesToShow: 2.1,
                            centerMode: true,
                            infinite: false
                        });*/

                        const lenght = $('.slideRecipes .slide').length

                        self.flickity = new Flickity('.slideRecipes', {
                            freeScroll: true,
                            contain: true,
                            prevNextButtons: false,
                            pageDots: false
                        });

                        let tapArea, startX ;
                        tapArea = document.querySelectorAll('.slide');
                        startX = 0;
                        for (let item of tapArea) {
                            item.ontouchstart = function(e) {
                                startX = e.touches[0].clientX;
                            };
                            item.ontouchmove = function(e) {
                                if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable ) {
                                    e.preventDefault();
                                }
                            };
                        }
                        
                    } else {
                        delete self.flickity;
                    }
                }, 500);
            },
            resizeFlickity() {
                if (this.flickity) {
                    this.flickity.resize();
                    document.querySelector('.flickity-viewport').style.height = null;
                }

            },
            init() {
                if (this.currentProduct.id != this.$route.query.product) {
                    this.$store.dispatch("product/getProduct", this.$route.query.product);
                } else {
                    this.initProduct()
                }
            },
            getLng() {
                return localStorage.getItem( 'lng' ) || 'en';
            }
        },
        created() {
            this.init();
            window.addEventListener("resize", this.resizeFlickity.bind(this));
        },
        updated() {

            this.init();
        },
        destroyed() {
            window.removeEventListener("resize", this.resizeFlickity);
        },
        watch: {
            currentProduct() {
                this.initProduct();
            }
        }
    }
</script>

